<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
    },
    name: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);
const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    },
});
</script>

<template>
    <div class="flex items-center">
        <input
            :name="name"
            :id="name"
            type="checkbox"
            class="text-primary focus:ring-primary h-4 w-4 rounded border-gray-300"
            v-model="model"
            :disabled="disabled"
        />
        <label :for="name" class="ml-4 flex items-center gap-2 text-sm font-medium text-gray-800">
            <slot name="icon" />
            <span>{{ label }}</span>
        </label>
    </div>
</template>
